export const floatingMenu = {
  floatingMenuHome: "Inicio",
  floatingMenuSlots: "Slots",
  floatingMenuGames: "Juegos",
  floatingMenuSports: "Deportes",
  floatingMenuLottery: "Lotería",
  floatingMenuCasino: "Casino",
  floatingMenuFeed: "Feed",
  floatingMenuBingo: "Bingo",
  floatingMenuToPlay: "Jugar",
  floatingMenuCategories: "Categorías",
  floatingMenuSeeAllGames: "Ir a todos los juegos",
  floatingMenuSeeAllSports: "Ir a todos",
};
